





























import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class GuideLayer extends Vue {
  @Prop() private showFlg!: boolean;
  private closePop() {
    this.$emit('update:showFlg', false);
  }
}
